// import Zv from 'zv';
class Controller {
	constructor(scope, options){
		this.scope = scope;
		if(typeof this.scope === "string"){
			this.scope = document.querySelector(this.scope);
		}
		if(!this.scope){
			throw new ElementNotFoundError('Scope element not found');
		}
		this.options = options || {};
	}
}